import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
    selector: 'unite-legalform-input',
    templateUrl: './legalform-input.component.html',
    styleUrls: ['./legalform-input.component.scss'],
    imports: [MatFormField, MatLabel, TranslateModule, MatSelect, ReactiveFormsModule, MatOption]
})
export class LegalFormInputComponent {

  legalFormControl = input<FormControl>();

}


